module.exports = __webpack_public_path__ + "static/media/gaming2.629df330.webp";